'use client'

import { Button } from './button'
import { useRouter } from 'next/navigation'

type Props = {
  error: { message: string, status: number } | any
} & ((React.ComponentPropsWithoutRef<'div'>))

export function Error({ error }: Props) {
  const { status, message } = error || {}
  const router = useRouter()
  return (
    <div className='flex flex-grow flex-col items-center justify-center w-full text-center my-8'>
      <div className='text-4xl font-bold font-serif text-red-800 pb-4'>{status || 500}</div>
      <div className='text-xl/10 font-medium'>
        {message || 'Something is wrong'}
      </div>
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <Button type='button' onClick={() => router.back()} className='w-32 rounded-full'>Go Back</Button>
      </div>
    </div>
  )
}
